<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title" :title1="title1" />
        <!-- /add -->
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-6 col-sm-6 col-12">
                <div class="form-group">
                  <label>Category Name</label>
                  <b-form-input type="text" v-model="form.categoryname" ref='firstInput' @keypress.enter="submitForm()"/>
                </div>
              </div>
              <div class="col-lg-6 col-sm-6 col-12">
                <div class="form-group">
                  <label>Category Code</label>
                  <b-form-input type="text"  v-model="form.categorycode" @keypress.enter="submitForm()"/>
                </div>
              </div>
              <div class="col-lg-12">
                <div class="form-group">
                  <label>Description</label>
                  <b-form-textarea
                    id="textarea"
                    v-model="form.description"
                    rows="3"
                    max-rows="6"
                    @keypress.enter="submitForm()"
                  ></b-form-textarea>
                </div>
              </div>

              <div class="col-lg-12">
                <div class="form-group">
                  <label>Category Image</label>
                  <div class="category-image-upload-control">
                    <input
                      ref="categoryFileInput"
                      type="file"
                      class="d-none"
                      accept="image/png,image/jpeg,image/jpg,image/webp"
                      @change="handleCategoryImageChange"
                    />
                    <button type="button" class="btn btn-outline-primary btn-sm" @click="$refs.categoryFileInput.click()">
                      Choose image
                    </button>
                    <span class="category-image-name">{{ categoryImageFile ? categoryImageFile.name : 'No file selected' }}</span>
                  </div>
                  <small class="form-hint">JPG, PNG, WEBP only · Max 1 MB</small>
                  <div v-if="categoryImagePreview || existingImageUrl" class="mt-3">
                    <div class="category-image-preview-card">
                      <img :src="categoryImagePreview || existingImageUrl" alt="Category image" />
                      <button type="button" class="btn btn-sm btn-danger mt-2" @click="removeCategoryImage">Remove image</button>
                    </div>
                  </div>
                  <small class="text-danger d-block mt-1" v-if="imageUploadError">{{ imageUploadError }}</small>
                </div>
              </div>

              <div class="col-lg-12">
                <a v-on:click="postData()" class="btn btn-submit me-2">Submit</a>
                <router-link to="categorylist" class="btn btn-cancel">Cancel</router-link>
              </div>
            </div>
          </div>
        </div>
        <!-- /add -->
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.post['Content-Type'] ='application/json;charset=utf-8';
export default {
  data() {
    return {
      form: {
        categoryname: '',
        categorycode: '',
        description: '',
      },
      categoryImageFile: null,
      categoryImagePreview: '',
      existingImageUrl: '',
      imageUploadError: '',
      title: "Item Add Category",
      title1: "Create new item category",
    };
  },
  methods: {
    handleCategoryImageChange(event) {
      const file = event.target.files && event.target.files[0];
      if (!file) return;

      const allowedTypes = ["image/png", "image/jpeg", "image/jpg", "image/webp"];
      const maxSizeBytes = 1 * 1024 * 1024;

      if (!allowedTypes.includes(file.type)) {
        this.imageUploadError = "Only JPG, JPEG, PNG or WEBP images are allowed.";
        event.target.value = null;
        return;
      }
      if (file.size > maxSizeBytes) {
        this.imageUploadError = "Image must be 1 MB or smaller.";
        event.target.value = null;
        return;
      }

      this.categoryImageFile = file;
      this.categoryImagePreview = URL.createObjectURL(file);
      this.existingImageUrl = '';
      this.imageUploadError = '';
    },

    removeCategoryImage() {
      if (this.categoryImagePreview) {
        URL.revokeObjectURL(this.categoryImagePreview);
      }
      this.categoryImageFile = null;
      this.categoryImagePreview = '';
      this.existingImageUrl = '';
      this.imageUploadError = '';
    },

    async uploadCategoryImage(categoryId) {
      if (!this.categoryImageFile) return null;
      const formData = new FormData();
      formData.append('image_file', this.categoryImageFile);
      const response = await axios.post(`/v1/category/${categoryId}/image`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return response.data;
    },

    async postData() {
      if (!this.form.categoryname) {
        Swal.fire("Please enter the category name");
        return;
      }
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: "Do you really want to submit the form?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, submit it!'
      });

      if (result.isConfirmed) {
        try {
          const response = await axios.post('/v1/category', this.form);
          const categoryId = response.data.categoryid || response.data.category_id || null;
          if (categoryId && this.categoryImageFile) {
            await this.uploadCategoryImage(categoryId);
          }
          Swal.fire("Category created successfully");
          this.$router.push({ path: '/categorylist' });
        } catch (error) {
          console.log(error);
          Swal.fire(error.response?.data?.detail || error.message);
        }
      }
    },
    submitForm() {
      this.postData();
    }
  },
  mounted(){
    this.$refs.firstInput.focus();
  },
  name: "addcategory",
};
</script>

<style scoped>
.category-image-upload-control {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
}
.category-image-name {
  color: #6c757d;
  font-size: 0.95rem;
}
.category-image-preview-card {
  max-width: 280px;
  padding: 0.75rem;
  border: 1px solid #e3e6f0;
  border-radius: 0.75rem;
  background: #fbfbff;
}
.category-image-preview-card img {
  width: 100%;
  height: auto;
  display: block;
  object-fit: contain;
  border-radius: 0.5rem;
  max-height: 200px;
}
</style>
